const data = {
  'Selected': 'Izabrano: {0} od {1}',
  'Uploading files': 'Nalaganje {0}% od {1}',
  'File size error': '{0} datoteka je prevelika, prosimo, naložite datoteko, manjšo od {1}',
  'Upload failed': '{0} napaka med nalaganjem',
  'Per page': '{0} Na stran',
  'Folder': 'Mapa',
  'Login failed, please try again': 'Neuspešna prijava, prosimo, poskusite ponovno',
  'Already logged in': 'Ste že prijavljeni.',
  'Please enter username and password': 'Vnesite uporabniško ime in geslo.',
  'Not Found': 'Ni najdeno',
  'Not Allowed': 'Ni dovoljeno',
  'Please log in': 'Prosimo, prijavite se',
  'Unknown error': 'Neznana napaka',
  'Add files': 'Dodaj datoteke',
  'New': 'Nov',
  'New name': 'Novo ime',
  'Username': 'Uporabniško ime',
  'Password': 'Geslo',
  'Login': 'Prijavi se',
  'Logout': 'Odjavi se',
  'Profile': 'Profil',
  'No pagination': 'Brez listanja po strani',
  'Time': 'Čas',
  'Name': 'Ime',
  'Size': 'Velikost',
  'Home': 'Začetna stran',
  'Copy': 'Kopiraj',
  'Move': 'Premakni',
  'Rename': 'Preimenuj',
  'Required': 'To polje je obvezno',
  'Zip': 'Zip',
  'Batch Download': 'Skupinsko nalaganje',
  'Unzip': 'Unzip',
  'Delete': 'Izbriši',
  'Download': 'Prenesi',
  'Copy link': 'Kopiraj link',
  'Done': 'Narejeno',
  'File': 'Datoteka',
  'Drop files to upload': 'Spusti datoteke za nalaganje',
  'Close': 'Zapri',
  'Select Folder': 'Izberi mapo',
  'Users': 'Uporabniki',
  'Files': 'Datotele',
  'Role': 'Pravice',
  'Cancel': 'Prekliči',
  'Paused': 'Prekini',
  'Confirm': 'Potrdi',
  'Create': 'Ustvari',
  'User': 'Uporabnik',
  'Admin': 'Administrator',
  'Save': 'Shrani',
  'Read': 'Branje',
  'Write': 'Pisanje',
  'Upload': 'Nalaganje',
  'Permissions': 'Pravice dostopa',
  'Homedir': 'Začetna',
  'Leave blank for no change': 'Pustite prazno, če ne želite spremeniti',
  'Are you sure you want to do this?': 'Ste prepričani?',
  'Are you sure you want to allow access to everyone?': 'Ste prepričani, da želite dovoliti dostop vsem?',
  'Are you sure you want to stop all uploads?': 'Ste prepričani, da želite prekiniti vse prenose?',
  'Something went wrong': 'Neznana napaka',
  'Invalid directory': 'Napačna mapa',
  'This field is required': 'To polje je obvezno',
  'Username already taken': 'Uporabniško ime že obstaja',
  'User not found': 'Uporabnik ni bil najden',
  'Old password': 'Staro geslo',
  'New password': 'Novo geslo',
  'Wrong password': 'Napačno geslo',
  'Updated': 'Posodobljeno',
  'Deleted': 'Zbrisano',
  'Your file is ready': 'Datoteka je pripravljena',
  'View': 'Poglej',
  'Search': 'Išči',
  'Download permission': 'Prenos',
  'Guest': 'Gost',
  'Show hidden': 'Prikaži skrito',
}

export default data

